import React from 'react';
import { Wrapper, Item1, Item2, Item3 } from './LoadingIndicator.styles';
const LoadingIndicator = () => (
  <Wrapper>
    <Item1 />
    <Item2 />
    <Item3 />
  </Wrapper>
);

export default LoadingIndicator
